import { render, staticRenderFns } from "./ReceivedCallsChart.vue?vue&type=template&id=13d49b2c&scoped=true"
import script from "./ReceivedCallsChart.vue?vue&type=script&lang=js"
export * from "./ReceivedCallsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d49b2c",
  null
  
)

export default component.exports